require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./douglas-county-in-custody-treatment-beds.json") })
        }
      }, "path---douglas-county-in-custody-treatment-beds");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---douglas-county-in-custody-treatment-beds!./.cache/json/douglas-county-in-custody-treatment-beds.json
// module id = 879
// module chunks = 231608221292675